import * as THREE from "three";
import { MTLLoader, OBJLoader } from "three-stdlib";
import OceanHotspot from "./OceanHotspot";

export default class Deck extends THREE.Group {
  constructor(config, scene) {
    super();

    new MTLLoader().load(config.materials, materials => {
      materials.preload();

      new OBJLoader().setMaterials(materials).load(config.model, object => {
        // object.rotation.x = - Math.PI / 2;
        object.castShadow = true;
        // object.receiveShadow = true;

        let max = 0;
        object.traverse(child => {
          if (child instanceof THREE.Mesh) {
            child.castShadow = true;
            // child.receiveShadow = true;

            for (const position of child.geometry.attributes.position.array) {
              const absPosition = Math.abs(position);
              if (absPosition > max) {
                max = absPosition;
              }
            }
          }
        });

        this.add(object);

        this.mesh = object;
        this.maxPosition = max;
      });
    });

    for (const hotspot of config.hotspots) {
      const h = new OceanHotspot(hotspot);
      this.add(h);

      h.setScale(0);

      scene.hotspots.push(h);
    }
  }
}
